import { environment } from "@environment/environment";

const BASE_PATH = `${environment.apiInfo.baseUrlGtPortal}/api/pp`;
const AUTH_BASE_PATH = `${environment.apiInfo.authBasePath}`;

export const API_FE_CONFIG = {
  POST_AUTH_PERMISSIONS: `${BASE_PATH}/auth/permissions`,
  POST_EPOLICY_SEARCH: `${BASE_PATH}/e-policy/policy-list`,
  POST_EPOLICY_COUNT: `${BASE_PATH}/e-policy/policy-count`,
  POST_EPOLICY_LOG_SEARCH: `${BASE_PATH}/e-policy/search-log`,
  POST_EPOLICY_SEND_EMAIL: `${BASE_PATH}/e-policy/send-policies`,
  POST_EPOLICY_GET_FILE_LIST: `${BASE_PATH}/e-policy/get-file-id`,
  POST_EPOLICY_GET_FILE_DOWNLOAD_URL: `${BASE_PATH}/e-policy/get-file-link`,
  POST_SSW_SALE_REPORT_SEARCH: `${BASE_PATH}/sale-report/ssw/search-reports`,
  POST_SSW_SALE_REPORT_COUNT: `${BASE_PATH}/sale-report/ssw/count-report`,
  POST_TG_SALE_REPORT_SEARCH: `${BASE_PATH}/sale-report/tg/search-reports`,
  POST_TG_SALE_REPORT_COUNT: `${BASE_PATH}/sale-report/tg/count-report`,
  POST_SALE_REPORT_EXPORT: `${BASE_PATH}/sale-report/export-reports`,
  POST_SALE_REPORT_DOWNLOAD: `${BASE_PATH}/sale-report/download-reports`,
  GET_AUTH_SIGNIN: `${AUTH_BASE_PATH}/signin`,
  GET_AUTH_TOKEN: `${AUTH_BASE_PATH}/token`,
  GET_AUTH_USER: `${AUTH_BASE_PATH}/user`,
};
